import { useContext, useEffect, useState } from 'react';
import { CatalogContext } from './Catalog.context';

export default function WheelControl() {
  const { paging, pagingPath, isResponsiveMode } = useContext(CatalogContext);
  const [onProgress, setOnProgress] = useState(false);
  const [timer, setTimer] = useState(null);

  const wheelHandler = e => {
    if (onProgress) {
      return;
    }
    if (e.deltaY === 0) {
      return;
    }

    setOnProgress(true);

    const dir = e.deltaY > 0 ? 'next' : 'prev';
    paging(dir);

    if (timer) {
      clearTimeout(timer);
    }

    const newTimer = setTimeout(() => {
      setOnProgress(false);
    }, 800);

    setTimer(newTimer);
  };

  useEffect(() => {
    if (!isResponsiveMode) {
      window.addEventListener('wheel', wheelHandler);
    } else {
      window.removeEventListener('wheel', wheelHandler);
    }
    return () => {
      window.removeEventListener('wheel', wheelHandler);
    };
  }, [onProgress, pagingPath, timer]);

  return null;
}
